import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {NavigationInfo} from "../models/topBarModel";
import {clearTopBarNavigation} from "../actions/menu/topBarAction";
import TopNav from "./nav/TopNav";
import AppSwitcherNav from "./nav/AppSwitcherNav";
import UserNav from "./nav/UserNav";
import {transferToProduct} from "../actions/nav/productTransferAction";
import BackNav from "./nav/BackNav";

class TopBar extends Component {

    static propTypes = {
        navigationInfo: PropTypes.shape(NavigationInfo),
        clearTopBarNavigation: PropTypes.func,
        history: PropTypes.object,
        location: PropTypes.object,
        transferToProduct: PropTypes.func
    };

    static defaultProps = {
        navigationInfo: undefined
    };

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.history.location !== prevProps.location) {
            this.props.clearTopBarNavigation();
        }
    }

    handleNavigation = () => {
        const {navigationInfo} = this.props;

        if (navigationInfo === undefined)
            return "";

        this.props.clearTopBarNavigation();

        this.props.history.push(navigationInfo.url);
    };

    render() {
        const {navigationInfo} = this.props;

        return <>
            <BackNav
                navigationInfo={navigationInfo}
                onNavigate={this.handleNavigation}
            />
            <TopNav>
                <AppSwitcherNav/>
                <UserNav/>
            </TopNav>
        </>;
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearTopBarNavigation: () => dispatch(clearTopBarNavigation()),
        transferToProduct: (productName) => dispatch(transferToProduct(productName))
    };
}

function mapStateToProps(state) {
    return {
        navigationInfo: state.topBar.navigationInfo
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopBar));
